import PropTypes from 'prop-types';
// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { TextField } from '@mui/material';

// ----------------------------------------------------------------------

RHFTextFieldV2.propTypes = {
  name: PropTypes.string,
  hasValue: PropTypes.bool,
  errorText: PropTypes.string,
};

export default function RHFTextFieldV2({ name, hasValue, errorText, ...other }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          fullWidth
          value={typeof field.value === 'number' && field.value === 0 ? '' : field.value}
          error={!!error}
          helperText={!hasValue ? errorText : error ? error?.message : ''}
          {...other}
        />
      )}
    />
  );
}
